// OAuth callback 라우트 경로. router와 redirect_uri 도출이 같은 값을 공유한다.
export const authCallbackPath = "/auth/callback";

// 현재 환경(로컬·dev 등)의 콜백 URL을 만든다. Overlord /start가 이 값을 허용목록
// (GITHUB_ALLOWED_REDIRECT_URIS)과 대조해 authorize_url에 싣고 token 교환에 재사용하므로,
// 단일 GitHub App으로 환경별 콜백을 처리하려면 프론트가 자기 origin을 명시해야 한다.
export function resolveGithubRedirectUri(): string {
  return `${window.location.origin}${authCallbackPath}`;
}
